import { render } from "./RedirectDomains.vue?vue&type=template&id=863639a6&ts=true"
import script from "./RedirectDomains.vue?vue&type=script&lang=ts"
export * from "./RedirectDomains.vue?vue&type=script&lang=ts"

import "./RedirectDomains.vue?vue&type=style&index=0&id=863639a6&lang=scss"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTable,QTd});
